import { ButtonUtils, FontUtils, Image3D, ObjectBuilder, Rectangle3D, RichTextGrammar, } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { text } from "../../TextResources";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { StringUtils } from "../utils/StringUtils";
export class BaseMenuHelpPanel {
    constructor(mesh2d, callbacks) {
        this._mesh2d = mesh2d;
        this._callbacks = callbacks;
        this.isVisible = false;
        const hp = Env.broadcast.menu.helpPanel;
        this._root = new Rectangle3D(`${this._getControlNamePrefix()}Root`);
        this._root.background = hp.root.background;
        this._root.cornerRadius = this._mesh2d.m2px(hp.root.cornerRadius);
        this._root.thickness = 0;
        this._mesh2d.texture.addControl(this._root);
        const header = new Container();
        header.background = hp.header.background;
        header.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        header.heightInPixels = this._mesh2d.m2px(hp.header.height);
        this._root.addControl(header);
        header.addControl(ObjectBuilder.createTextBlock3D(this._mesh2d, `${this._getControlNamePrefix()}HeaderText`, text.broadcast_menu_helpPanel_header, hp.header.caption));
        const closeButton = ButtonUtils.CreateImgButton(`${this._getControlNamePrefix()}CloseButton`, hp.closeButton, this._mesh2d);
        closeButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        closeButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        closeButton.topInPixels = this._mesh2d.m2px(hp.closeButton.top);
        closeButton.leftInPixels = this._mesh2d.m2px(-hp.closeButton.right);
        closeButton.onClickObserver.add(() => {
            setTimeout(() => {
                this.hide();
                callbacks.onClose();
            }, 0);
        });
        this._root.addControl(closeButton);
        this._createContent();
    }
    _addDragSection() {
        const hp = Env.broadcast.menu.helpPanel;
        const dragSection = new StackPanel(`${this._getControlNamePrefix()}DragSection`);
        dragSection.isVertical = true;
        dragSection.spacing = this._mesh2d.m2px(hp.sectionSpacing);
        dragSection.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        dragSection.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._root.addControl(dragSection);
        dragSection.addControl(ObjectBuilder.createTextBlock3D(this._mesh2d, `${this._getControlNamePrefix()}DragHeader`, text.broadcast_menu_helpPanel_drag_header, hp.sectionHeader));
        dragSection.addControl(ObjectBuilder.createRichTextBlock3D(`${this._getControlNamePrefix()}DragText`, StringUtils.stringFormat(text.broadcast_menu_helpPanel_drag_text, hp.highlightedText.background, this._mesh2d.m2px(hp.highlightedText.backgroundRadius), this._mesh2d.m2px(hp.highlightedText.backgroundPadding.horizontal), this._mesh2d.m2px(hp.highlightedText.backgroundPadding.vertical), hp.highlightedText.fontWeight), hp.sectionText, RichTextGrammar.RTTag, this._mesh2d));
        return dragSection;
    }
    _addCloseSection() {
        const hp = Env.broadcast.menu.helpPanel;
        const closeSection = new StackPanel(`${this._getControlNamePrefix()}CloseSection`);
        closeSection.isVertical = true;
        closeSection.spacing = this._mesh2d.m2px(hp.sectionSpacing);
        closeSection.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        closeSection.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._root.addControl(closeSection);
        closeSection.addControl(ObjectBuilder.createTextBlock3D(this._mesh2d, `${this._getControlNamePrefix()}CloseHeader`, text.broadcast_menu_helpPanel_close_header, hp.sectionHeader));
        closeSection.addControl(ObjectBuilder.createRichTextBlock3D(`${this._getControlNamePrefix()}CloseText`, StringUtils.stringFormat(text.broadcast_menu_helpPanel_close_text, hp.highlightedText.background, this._mesh2d.m2px(hp.highlightedText.backgroundRadius), this._mesh2d.m2px(hp.highlightedText.backgroundPadding.horizontal), this._mesh2d.m2px(hp.highlightedText.backgroundPadding.vertical), hp.highlightedText.fontWeight), hp.sectionText, RichTextGrammar.RTTag, this._mesh2d));
        return closeSection;
    }
    _addLabel(name, text, style) {
        const hp = Env.broadcast.menu.helpPanel;
        this._root.addControl(ObjectBuilder.createTextBlock3D(undefined, `${this._getControlNamePrefix()}${name}Label`, text, FontUtils.getAdjustedFontStyle(style, this._mesh2d, hp.controller.text)));
    }
    _addSubLabel(name, style) {
        const hp = Env.broadcast.menu.helpPanel;
        this._root.addControl(ObjectBuilder.createTextBlock3D(undefined, `${this._getControlNamePrefix()}${name}SubLabel`, text.broadcast_menu_helpPanel_controller_long_press, FontUtils.getAdjustedFontStyle(style, this._mesh2d, hp.controller.longPressText)));
    }
    _addIcon(name, url, position) {
        const hp = Env.broadcast.menu.helpPanel;
        const img = new Image3D(`${this._getControlNamePrefix()}${name}Icon`, url);
        img.widthInPixels = this._mesh2d.m2px(hp.controller.icons.width);
        img.heightInPixels = this._mesh2d.m2px(hp.controller.icons.height);
        img.leftInPixels = this._mesh2d.m2px(position.left);
        img.topInPixels = this._mesh2d.m2px(position.top);
        img.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        img.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._root.addControl(img);
    }
    get isVisible() {
        return this._mesh2d.isVisible;
    }
    set isVisible(value) {
        if (!this.isVisible && value) {
            this._callbacks.onShow();
        }
        this._mesh2d.isVisible = value;
    }
    show() {
        this.isVisible = true;
    }
    hide() {
        this.isVisible = false;
    }
}
